import Entry from 'admin-config/lib/Entry';

export default function maInputArray(Restangular, $timeout) {
    return {
        scope: {
            'field': '&',
            'value': '=',
            'entry': '&'
        },
        restrict: 'E',
        link: {
            pre: function (scope) {
                const field = scope.field();
                const targetEntity = field.targetEntity();
                const targetEntityName = targetEntity.name();
                const targetFields = field.targetFields();
                const sortField = field.sortField();
                const sortDir = field.sortDir() === 'DESC' ? -1 : 1;
                let filterFunc;


                if (field.permanentFilters()) {
                    const filters = field.permanentFilters();
                    const filterKeys = Object.keys(filters);
                    filterFunc = (entry) => {
                        return filterKeys.reduce((isFiltered, key) => isFiltered && entry.values[key] === filters[key], true);
                    };
                } else {
                    filterFunc = () => true;
                }
                scope.fields = angular.copy(targetFields);
                scope.field_games_default = scope.fields.pop();
                scope.field_games = [];
                scope.field_no_games = [];
                scope.timer = [];
                scope.globalTimer = null;
                scope.changer = null;

                scope.targetEntity = targetEntity;
                scope.entries = Entry
                    .createArrayFromRest(scope.value || [], targetFields, targetEntityName, targetEntity.identifier().name())
                    .sort((entry1, entry2) => {
                        // use < and > instead of substraction to sort strings properly
                        if (entry1.values[sortField] > entry2.values[sortField]) {
                            return sortDir;
                        }
                        if (entry1.values[sortField] < entry2.values[sortField]) {
                            return -1 * sortDir;
                        }
                        return 0;
                    })
                    .filter(filterFunc);
                scope.addNew = () => {
                    scope.entries.push(Entry.createForFields(targetFields));
                    /*Add new ability with the % of the numTotal of abilities and update the rest*/
                    let addNewWeight = Math.round(100 / scope.entries.length);
                    let index = scope.entries.length - 1;
                    scope.entries[index].values.weight = addNewWeight;
                    scope.updateWeights(addNewWeight, index);
                };

                scope.remove = entry => {
                    /*Update rest of abilities on remove*/
                    scope.entries = scope.entries.filter(e => e !== entry);
                    scope.updateWeights(0, null);

                };
                scope.$watch('entries', (newEntries, oldEntries) => {
                    if (newEntries === oldEntries) {
                        return;
                    }
                    scope.value = newEntries.map(e => e.transformToRest(targetFields));

                }, true);

                scope.$watch('value', (newValue, oldValue) => {

                    for (let i in oldValue) {

                        newValue[i] = controlValue(newValue[i], i);


                        if (newValue[i] && oldValue[i] && oldValue[i].ability != newValue[i].ability) {
                            let ability = newValue[i].ability;
                            scope.updateChoices(ability, i);
                        }

                        if (newValue[i] && oldValue[i] && oldValue[i].weight != newValue[i].weight) {
                            let weight = newValue[i].weight;

                            if (scope.timer[i] != null)
                                $timeout.cancel(scope.timer[i]);

                            scope.timer[i] = $timeout(function () {
                                scope.updateWeights(weight, i);
                            }, 1000);
                        }
                    }
                }, true);

                scope.updateWeights = function (weight, index) {

                    if (scope.changer == null) {
                        scope.changer = index;

                        $timeout.cancel(scope.globalTimer);

                        scope.globalTimer = $timeout(function () {
                            updateAllWeight(weight, index);
                            $timeout(function () {
                                for (let i = 0; i < scope.entries.length; i++) {
                                    $timeout.cancel(scope.timer[i]);
                                }
                                scope.changer = null;
                            }, 10);

                        }, 10);
                    }
                }

                function controlValue(newV, index) {
                    /*control value and restriction of new ability*/
                    if (newV) {

                        if (newV.weight == 'undefined') {
                            return scope.entries[index].values.weight = 1;
                        } else if (isNaN(newV.weight)) {
                            return scope.entries[index].values.weight = 1;
                        } else if (!newV.weight) {
                            return scope.entries[index].values.weight = 1;
                        } else if (newV.weight < 1) {
                            scope.entries[index].values.weight = 1;
                        } else if (newV.weight > 100) {
                            scope.entries[index].values.weight = 100;
                        } else if (newV.weight > 0) {
                            scope.entries[index].values.weight = scope.entries[index].values.weight * 1;
                            return newV;
                        } else {
                            return newV;
                        }
                    }
                }


                function updateAllWeight(weight, index) {
                    let numEntries = scope.entries.length;
                    let totalAbilities = 0.0;
                    let newValues = [];
                    let value = 0.0;

                    /*total weight of ability*/
                    for (let i = 0; i < numEntries; i++) {
                        if (scope.entries[i].values.weight) {
                            totalAbilities = parseInt(scope.entries[i].values.weight) + totalAbilities;
                        }
                    }

                    /*calculate diff in % of totalAbilities - 100 */
                    if (totalAbilities != 100) {
                        let totalChangeAbilities = (totalAbilities - 100) / 100;
                        let difChange = totalAbilities - weight;

                        for (let x = 0; x < numEntries; x++) {
                            if (x != index) {
                                newValues[x] = scope.entries[x].values.weight * (100 / difChange);
                            }
                        }
                        /*apply % of the diff in % of total weight to the rest abilities*/
                        for (let x = 0; x < numEntries; x++) {
                            if (scope.entries[x].values.weight != weight) {
                                value = parseInt(scope.entries[x].values.weight) - (newValues[x] * totalChangeAbilities);
                                scope.entries[x].values.weight = value;
                                ;
                            }
                        }
                    }
                }

                function getAge(dateString) {
                    var today = new Date();
                    var birthDate = new Date(dateString);
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                        age--;
                    }
                    return age;
                }


                scope.updateChoices = function (ability, index) {
                    if (scope.field_games[index]) delete scope.field_games[index];

                    var years = 0;

                    if(scope.$parent.entry.values.birthday){
                        years = getAge(scope.$parent.entry.values.birthday);
                    }
                    if(scope.$parent.entry.values.maturative){
                        years = getAge(scope.$parent.entry.values.maturative);
                    }


                    Restangular
                        .all('games')
                        .getList({_sortField: "name", _sortDir: "ASC", _filters: '{"ability": ' + ability + ', "age": '+ years +'}'})
                        .then(data => {
                            data = data.data ? data.data : data;

                            if (!data.length) return scope.field_no_games[index] = true;

                            scope.field_games[index] = angular.copy(scope.field_games_default);
                            scope.field_games[index]._choices = data.map(function (ability) {
                                return {
                                    value: ability.id,
                                    label: ability.name
                                };
                            });
                            scope.field_no_games[index] = false;
                        });
                }

                Restangular
                    .all('abilities')
                    .getList({sort: '["name","DESC"]'})
                    .then(abilities => {
                        scope.abilities = abilities.data.map(function (ability) {
                            return {
                                value: ability.id,
                                label: ability.name
                            };
                        });
                    });

                scope.choices = function () {
                    return scope.abilities;
                };

                for (let i in scope.entries) {
                    scope.updateChoices(scope.entries[i].values.ability, i);
                }

            }
        },
        template: `
<div class="row input-array">
    <div class="col-sm-12">
    <table class="table table-striped">
        <thead> 
            <tr> 
                <th>{{ 'ABILITY' | translate }}</th> 
                <th>{{ 'PERCENTAGE' | translate }}</th> 
                <th></th>
            </tr>
        </thead>
        <tbody ng-repeat="entry in entries track by $index" name="subform_{{$index}}" ng-init="formName = 'subform_' + $index"> 
            <tr>
                <td ng-repeat="field in ::fields track by $index">
                    <ma-choice-field ng-if="field.name() == 'ability' && abilities" field="::field" value="entry.values[field.name()]" choices="choices()"></ma-choice-field>            
                    <ma-field ng-if="field.name() == 'weight'" field="::field" value="entry.values[field.name()]" entry="entry" entity="::targetEntity" form="formName" datastore="::datastore()"></ma-field>
                </td> 
                <td>
                    <a class="remove" ng-click="remove(entry)"><span class="glyphicon glyphicon-minus-sign" aria-hidden="true"></span>&nbsp;</a>
                </td>
            </tr>
            <tr>
                <td colspan="3">
                    <div ng-if="field_no_games[$index]">No games</div>
                    <ma-choices-field ng-if="field_games[$index]" field="field_games[$index]" value="entry.values[field_games_default.name()]" entry="::entry"></ma-choices-field>      
                </td>
            </tr>
        </tbody>
    </table>
    
    <div class="form-group">
        <div class="col-sm-12">
            <a class="btn btn-default" ng-click="addNew()"><span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span>&nbsp;<span translate="ADD" translate-values="{ name: field().name() }"></span></a>
        </div>
    </div>
</div>`
    };
}

maInputArray.$inject = [];


/** WEBPACK FOOTER **
 ** ./js/directives/ma_abilities.js
 **/